var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ymap-conatainer"},[_c('Button',{attrs:{"label":"Посмотреть на карте","action":_vm.showModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }